import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { useAbacSessionPending } from "../../hooks/useAbacAccess";
import { useInactive } from "../../hooks/useInactive";
import { hasRole, hasRoles } from "../../lib/utility";
import { authSelector } from "../Auth/AuthSlice";
import NavAccessGuard from "./NavAccessGuard";
import RedirectToDashboard from "./RedirectToDashboard";
import RedirectToLogin from "./RedirectToLogin";
import SuspenseLoader from "./SuspenseLoader";

const ProtectedRoute = ({ role }) => {
  const { user } = useSelector(authSelector);
  const abacPending = useAbacSessionPending();

  useInactive(user, +(import.meta.env.VITE_REACT_APP_STALL_TIME || "0"));

  if (role === "public") {
    return (
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    );
  }

  if (role === "guest") {
    if (!hasRole(user) || !globalThis.isAuthenticated) {
      return (
        <SuspenseLoader>
          <Outlet />
        </SuspenseLoader>
      );
    }
    return <RedirectToDashboard />;
  }

  if (
    !user.roles &&
    (window.location.href !== "/login" || window.location.href !== "/")
  ) {
    return <RedirectToLogin />;
  }

  if (abacPending) return null;

  if (hasRoles(role, user)) {
    if (globalThis.isAuthenticated) {
      // Sidebar-aligned path ACL; denied URLs → RedirectToDashboard / NoAccessPage
      return <NavAccessGuard />;
    }
    return <RedirectToLogin />;
  }

  return <RedirectToDashboard />;
};

export default ProtectedRoute;
